<template>
  <div class="event-bubble">
    <h2>Details & Anmeldung</h2>

    <template v-if="nextEvent">
      <strong>Nächster Termin: </strong>
      <span>{{ formatDate(nextEvent.startDate) }}, {{ nextEvent.startTime }} Uhr</span><br />
      <strong>Ort: </strong><span>{{ nextEvent.location }}</span><br />
      <strong>Dauer: </strong><span>ca. {{ getDurationText(nextEvent.startTime, nextEvent.endTime) }}</span><br />
      <strong>Kosten: </strong><span>30€ pro Person bzw. 45€ pro Paar</span><br />
      <strong>Extras: </strong>
      <span>Ihr erhaltet im Anschluss ein ausführliches Handout.</span><br /><br />
    </template>

    <template v-else>
      <strong>Aktuell kein Termin geplant.</strong><br />Falls du Interesse hast, melde dich gerne bei mir!
      <strong>Ort: </strong><span>Koblenz-Metternich oder Online</span><br />
      <strong>Dauer: </strong><span>ca. 2 Stunden</span><br />
      <strong>Kosten: </strong><span>30€ pro Person bzw. 45€ pro Paar</span><br />
      <strong>Extras: </strong>
      <span>Ihr erhaltet im Anschluss ein ausführliches Handout.</span><br /><br />
    </template>

    <a :href="mailtoLink" class="cta-button">
      {{ nextEvent ? "Jetzt anmelden" : "Unverbindlich anfragen" }}
    </a>
    <span><br /><br /></span>
  </div>
</template>

<script>
import events from "@/data/events.js";

export default {
  name: "NextEventBubble",
  data() {
    return {
      infoVisibleId: null,
      defaultOrganizer: {
        type: "Person",
        name: "Maikes Familienbegleitung",
        url: "https://maikes-familienbegleitung.de"
      },
      defaultPerformer: {
        name: "Maike Röhrig"
      },
      defaultDescription: "Ein interaktiver Kurs mit praktischen Tipps und individueller Beratung.",
      defaultImage: "https://maikes-familienbegleitung.de/favicon.svg",
      defaultPrice: "30",
      defaultOfferUrl: "https://maikes-familienbegleitung.de/preise",
      defaultAddress: {
        streetAddress: "Trierer Strasse 250a",
        addressLocality: "Koblenz",
        postalCode: "56072",
        addressCountry: "DE"
      }
    };
  },
  mounted() {
    if (this.nextEvent != null) {
      const event = this.nextEvent;
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        "name": event.name,
        "description": event.description || this.defaultDescription,
        "image": event.image || this.defaultImage,
        "startDate": `${event.startDate}T${event.startTime}:00+02:00`,
        "endDate": `${event.endDate}T${event.endTime}:00+02:00`,
        "location": event.isOnline
          ? { "@type": "VirtualLocation", "url": "https://zoom.us" }
          : {
              "@type": "Place",
              "name": event.location,
              "address": event.address || this.defaultAddress
            },
        "eventAttendanceMode": event.isOnline
          ? "https://schema.org/OnlineEventAttendanceMode"
          : "https://schema.org/OfflineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "offers": {
          "@type": "Offer",
          "url": event.eventUrlRelative
            ? "https://maikes-familienbegleitung.de" + event.eventUrlRelative
            : event.eventUrlExtern
                ? event.eventUrlExtern
                : this.defaultOfferUrl,
          "price": event.price || this.defaultPrice,
          "priceCurrency": "EUR",
          "availability": "https://schema.org/InStock",
          "validFrom": "2025-03-01"
        },
        "organizer": event.organizer || this.defaultOrganizer,
        "performer": event.performer
          ? { "@type": "Person", "name": event.performer }
          : { "@type": "Person", "name": this.defaultPerformer }
      }, null, 2);
      document.head.appendChild(script);
    }
  },
  computed: {
    nextEvent() {
      const today = new Date().toISOString().split("T")[0];
      const currentPath = this.$route.path;
      const filtered = events
        .filter(e => e.eventUrlRelative === currentPath && e.startDate >= today)
        .sort((a, b) => a.startDate.localeCompare(b.startDate));
      return filtered[0] || null;
    },
    mailtoLink() {
      const email = "info@maikes-familienbegleitung.de";

      if (this.nextEvent) {
        const subject = `Anmeldung ${this.nextEvent.name} ${this.formatDate(this.nextEvent.startDate)}`;
        const body = `Liebe Maike,%0D%0A%0D%0Aich möchte mich gerne zum ${this.nextEvent.name} am ${this.formatDate(this.nextEvent.startDate)} um ${this.nextEvent.startTime} Uhr anmelden.%0D%0A%0D%0AViele Grüße`;
        return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${body}`;
      } else {
        const subject = `Anfrage zu Workshop-Termin`;
        const body = `Liebe Maike,%0D%0A%0D%0Aich interessiere mich für einen Workshop zum Thema [Stillen/Schlafen/Beikost]. Bitte gib mir Bescheid, sobald ein neuer Termin geplant ist.%0D%0A%0D%0AViele Grüße`;
        return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${body}`;
      }
    }
  },
  methods: {
    formatDate(isoDate) {
      const date = new Date(isoDate);
      return date.toLocaleDateString("de-DE", {
        weekday: "short",
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    getDurationText(start, end) {
      const [startHour, startMinute] = start.split(":").map(Number);
      const [endHour, endMinute] = end.split(":").map(Number);
      const startDate = new Date(0, 0, 0, startHour, startMinute);
      const endDate = new Date(0, 0, 0, endHour, endMinute);
      let diffMs = endDate - startDate;
      if (diffMs < 0) diffMs += 24 * 60 * 60 * 1000;
      const diffHours = diffMs / (1000 * 60 * 60);
      return `${diffHours % 1 === 0 ? diffHours : diffHours.toFixed(1)} Stunden`;
    }
  }
};
</script>

<style scoped>
.event-bubble {
  position: absolute;
  top: 15rem;
  right: 1rem;
  background-color: var(--main-color-2);
  color: var(--font-color);
  padding: 10px 15px;
  border-radius: 12px;
  font-size: 0.9rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  max-width: 20rem;
}
@media (max-width: 70rem) {
  .event-bubble {
    position: relative;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
